import React from 'react';
import PrimeCursosFAQ from './components/PrimeCursosFAQ';
import './App.css';

function App() {
  return (
    <div className="App">
      <PrimeCursosFAQ />
    </div>
  );
}

export default App;